<template>
  <div>
    <div class="flex flex-col bg-gray-academy-900 mx-6 relative">
      <div class="w-full">
        <img class="w-full"
        :src="masterclass.teacher.urlProfilePhoto" />
      </div>
      <div class="h-20 flex w-full bg-background-academy absolute bottom-0 px-3
      bg-opacity-90">
        <div class="w-1/2 flex flex-col items-center
          justify-center">
          <span class="text-white border-b border-orange-academy-150 w-full pb-1
          text-lg font-black z-10 opacity-100 flex justify-start pl-2">
            {{ masterclass.teacher.name }}
          </span>
          <masterclass-date class="text-white pt-1 pl-2 w-full" :masterclass="masterclass" />
        </div>
        <div class="flex justify-end w-1/2 items-center">
          <router-link class="flex bg-white text-orange-academy-150 uppercase rounded-xl text-sm
            border border-orange-academy-150 hover:bg-orange-academy-150 hover:text-white h-10
            items-center px-2"
            :to="'/masterclasses/'+masterclass.id">
            {{ $t('masterclass.seeMore') }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MasterclassDate from './MasterclassDate.vue';

export default {
  props: ['masterclass'],

  components: {
    MasterclassDate,
  },
};
</script>
